import { getResourceTo } from 'react/utils/utils';

/**
 * Factory function to create route action menu items
 * Following the Factory Method pattern and Single Responsibility Principle
 *
 * @param {Object} routeActions - The actions from useRouteActions hook
 * @param {Object} route - The route object
 * @param {Array} equipmentAssignments - Equipment assignments for the route
 * @param {Object} permissions - Permission flags
 * @returns {Array} Array of menu items
 */
export const createRouteMenuItems = (
  routeActions,
  route,
  equipmentAssignments,
  permissions
) => {
  const menus = [];

  const addMenuItem = (condition, menuItem) => {
    if (condition) {
      menus.push(menuItem);
    }
  };

  addMenuItem(true, {
    iconClass: 'MonetUIMenuRouteIcon viewRouteDetails',
    type: 'view-route-details',
    name: getResourceTo('Routesummary.Menu.Viewroutedetails'),
    onClick: routeActions.navigateToRouteDetails
  });

  addMenuItem(permissions.canGoToRouteSummary, {
    iconClass: 'MonetUIMenuRouteIcon viewRouteSummary',
    name: getResourceTo('RouteMonitor.Menu.ViewRouteSummary'),
    type: 'view-route-summary',
    onClick: routeActions.navigateToRouteSummary
  });

  addMenuItem(equipmentAssignments && equipmentAssignments.length > 0, {
    iconClass: 'MonetUIMenuRouteIcon focusOnMap',
    name: getResourceTo('RouteMonitor.filter.equipmentFocus'),
    type: 'focus-on-map',
    onClick: () => routeActions.focusOnMap(equipmentAssignments)
  });

  addMenuItem(permissions.canCloneRoute, {
    iconClass: 'MonetUIMenuRouteIcon cloneRouteBtn',
    type: 'clone-route',
    name: getResourceTo('Greenmile.Route.Clone.btnSave'),
    onClick: routeActions.cloneRoute
  });

  addMenuItem(permissions.canEditRoute, {
    iconClass: 'MonetUIMenuRouteIcon editRouteBtn',
    name: getResourceTo('RouteMonitor.Menu.EditRoute'),
    type: 'edit-route',
    onClick: routeActions.navigateToRouteEdit
  });

  addMenuItem(route.status === 'NOT_STARTED' && permissions.canStartRoute, {
    name: getResourceTo('Greenmile.Route.Start.btnSave'),
    iconClass: 'MonetUIMenuRouteIcon startRouteBtn',
    type: 'start-route',
    onClick: routeActions.startRoute
  });

  addMenuItem(route.status === 'ARRIVED_ORIGIN' && permissions.canCompleteRoute, {
    iconClass: 'MonetUIMenuRouteIcon completeRouteBtn',
    name: getResourceTo('Greenmile.Route.Complete.btnSave'),
    type: 'complete-route',
    onClick: routeActions.completeRoute
  });

  addMenuItem(route.status === 'STARTED' && permissions.canDepartFromOrigin, {
    name: getResourceTo('Greenmile.Route.DepartOrigin.btnSave'),
    iconClass: 'MonetUIMenuRouteIcon departOriginBtn',
    type: 'depart-origin',
    onClick: routeActions.departOrigin
  });

  addMenuItem(route.status === 'DEPARTED_ORIGIN' && permissions.canArriveAtDestination, {
    name: getResourceTo('Greenmile.Route.ArriveDestination.btnSave'),
    iconClass: 'MonetUIMenuRouteIcon arriveDestinationBtn',
    type: 'arrive-destination',
    onClick: routeActions.arriveDestination
  });

  addMenuItem(route.status !== 'COMPLETED' && permissions.canTransferStops, {
    iconClass: 'MonetUIMenuRouteIcon transferStops',
    type: 'transfer-stops',
    name: getResourceTo('RouteMonitor.filter.transferStop'),
    onClick: routeActions.transferStops
  });

  addMenuItem(permissions.canShowOtherData, {
    iconClass: 'MonetUIMenuRouteIcon otherDataBtn',
    type: 'other-data',
    name: getResourceTo('Greenmile.Route.Other.Data'),
    onClick: routeActions.showOtherData
  });

  return menus;
};

export default createRouteMenuItems;
